import { Theme } from '@mui/material/styles';

export const MULTI_DAY_SHIFT_GROUP_COLOR_KEYS = [
  'rose',
  'purple',
  'orange',
  'amber',
] as const satisfies ReadonlyArray<keyof Theme['palette']['lwMultiDayShiftGroup']>;

export type MultiDayShiftGroupColorKey = (typeof MULTI_DAY_SHIFT_GROUP_COLOR_KEYS)[number];

export const getMultiDayShiftGroupColors = (theme: Theme): string[] =>
  MULTI_DAY_SHIFT_GROUP_COLOR_KEYS.map((colorKey) => theme.palette.lwMultiDayShiftGroup[colorKey]);

const hashString = (value: string): number => {
  let hash = 0;
  for (let index = 0; index < value.length; index++) {
    hash = (hash << 5) - hash + value.charCodeAt(index);
    hash |= 0;
  }
  return Math.abs(hash);
};

export const getMultiDayShiftAccentColor = (multiDayShiftId: string, theme: Theme): string => {
  const groupColors = getMultiDayShiftGroupColors(theme);
  const colorIndex = hashString(multiDayShiftId) % groupColors.length;
  return groupColors[colorIndex];
};
